<template>
  <div>
    <!-- Add Google Fonts -->
    <link rel="preconnect" href="https://fonts.googleapis.com">
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
    <link href="https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400;700&family=Lobster&family=Open+Sans:wght@400;700&family=Pacifico&family=Playfair+Display:wght@400;700&family=Poppins:wght@400;700&family=Raleway:wght@400;700&family=Roboto:wght@400;700&family=Rock+Salt&display=swap" rel="stylesheet">
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <div class="col-sm-12 ">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainee/traineeDashboard'
                    },
                   {
                      title: 'Certificate',
                      active: true
                    },
                  ]"
            ></vs-breadcrumb>

            <template>
              <div class="container">
                <div class="form-group form-row text-dark mt-3">
                  <h6 class="sub-frm-title">Event Information</h6>
                  <div class="row col-sm-12">
                    <label class="col-sm-1 font-weight-bold">Title:</label>
                    <div class="col-sm-11">{{title}}</div>
                  </div>
                </div>
                <h2 style="text-align: center;">DOWNLOAD CERTIFICATE</h2>
                <div class="row">
                  <div class="col-12 d-flex">
                    <button
                      class="btn download-btn ml-auto"
                      @click="downloadPDF"
                    >
                      Download PDF
                    </button>
                  </div>
                </div>

                <canvas ref="certificateCanvas"></canvas>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import VueGallerySlideshow from "vue-gallery-slideshow";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";

import {
    jsPDF
} from "jspdf";

export default {
    data: () => ({
        isSidebar: false,
        title: "",
        images: [],
        index: null,
        trainingId: "",
        trainingCode: "",
        BASEPATHDYNAMIC: "",
        imagess: [],
        isFile: false,
        imageUrl: '',
        textElements: {},
        canvas: null,
        ctx: null,
        img: new Image(),

    }),
    mounted() {

        this.canvas = this.$refs.certificateCanvas;
        this.ctx = this.canvas.getContext("2d");

        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.BASEPATHDYNAMIC = localStorage.getItem("BASE_PATH");
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                localStorage.getItem("BASE_PATH") +
                "/trainee/training/single/" +
                this.trainingCode + "/get"

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.id;
                this.title = response.data.title;
                this.getTraining(response.data.id)

            });
    },
    components: {
        VueGallerySlideshow,
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,

    },
    methods: {

        getTraining(id) {
            this.openLoading();
            axios
                .get(localStorage.getItem("BASE_PATH") + "/admin/upload-certificates/" + id)
                .then(response => {
                    if (response) {
                        if(response.data.length > 0) {
                        const certificateData = response.data[0]; // Fixing incorrect data reference
                        const currentUser = JSON.parse(localStorage.getItem("currentUser"));

                        // Set text elements for rendering
                        this.textElements = {
                            text: currentUser ? currentUser.name : " ",
                            x: certificateData.xAxis,
                            y: certificateData.yAxis,
                            fontSize: certificateData.fontSize,
                            color: certificateData.fontColor,
                            fontFamily: certificateData.fontFamily
                        };

                        this.imageUrl = localStorage.getItem("BASE_PATH") + "/" + certificateData.uploadfile

                            this.loadImage();
                        }
                        else {
                            this.$toasted.global.errorMsg('No certificate found');
                            this.closeLoading();
                            setTimeout(() => {
                                this.$router.push("/dashboard/Trainee/traineeDashboard");
                            }, 1000);
                        }
                    }
                })
        },

        loadImage() {
            this.img = new Image();
            this.img.crossOrigin = "Anonymous"; // Prevent CORS issues if needed

            this.img.onload = () => {
                this.adjustCanvasSize();
                this.drawCanvas();
            };
            this.img.src = this.imageUrl;
        },
        drawCanvas() {
            if (!this.canvas || !this.ctx || !this.img) return;

            // Clear canvas
            this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

            // Draw the certificate image
            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
        },

        downloadPDF() {
            const pdf = new jsPDF("landscape", "pt", [this.canvas.width, this.canvas.height]);
            const imgData = this.canvas.toDataURL("image/png");
            pdf.addImage(imgData, "PNG", 0, 0, this.canvas.width, this.canvas.height);
            pdf.save("certificate.pdf");
        },

        adjustCanvasSize() {
            const maxWidth = window.innerWidth * 0.9;
            const maxHeight = window.innerHeight * 0.8;
            const aspectRatio = this.img.naturalWidth / this.img.naturalHeight;

            if (aspectRatio > 1) {
                this.canvas.width = Math.min(maxWidth, this.img.naturalWidth);
                this.canvas.height = this.canvas.width / aspectRatio;
            } else {
                this.canvas.height = Math.min(maxHeight, this.img.naturalHeight);
                this.canvas.width = this.canvas.height * aspectRatio;
            }

            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
            setTimeout(() => {
                this.renderText();
                 this.closeLoading();
            }, 1000);
        },

        renderText() {
            this.ctx.drawImage(this.img, 0, 0, this.canvas.width, this.canvas.height);
            const el = this.textElements;
            
            // Wait for font to load before rendering
            document.fonts.ready.then(() => {
                this.ctx.font = `${el.fontSize}px "${el.fontFamily}"`;
                this.ctx.fillStyle = el.color;
                this.ctx.textAlign = "center";
                this.ctx.fillText(el.text, el.x, el.y);

                // Draw "This is TMIS generated certificate" in rotated position
                this.ctx.save();
                const midLeftX = 50;
                const midLeftY = this.canvas.height / 2;
                this.ctx.translate(midLeftX, midLeftY);
                this.ctx.rotate(-Math.PI / 2);
                this.ctx.font = "14px Arial";
                this.ctx.fillStyle = "rgba(0, 0, 0, 0.5)";
                this.ctx.textAlign = "center";
                this.ctx.fillText("This is TMIS generated certificate", 0, 30);
                this.ctx.restore();
            });
        },

        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        onClick(i) {
            this.index = i;
        }
    }
};
</script>

<style scoped>
#menu-toggle {
    display: none;
}

@media (max-width: 768px) {
    #menu-toggle {
        display: block;
    }
}

.gallery-image {
    width: 100%;
    height: 200px;
    background-size: contain;
    cursor: pointer;
    /* margin: 10px; */
    border-radius: 3px;
}

.frm-title {
    text-align: center;
    padding: 10px;
    color: #009ad2;
    /* border-bottom: 2px solid #009ad2; */
}

.vgs__container {
    height: 75vh !important;
}

/* thumbnail hover css starts */

.tiles {
    width: 420px;
    font-size: 0;
    /* text-align: center;
  position: absolute; */
    /* top: 50%;
  left: 50%; */
    /* -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%); */
}

.tiles .tile {
    display: inline-block;
    margin: 10px;
    text-align: left;
    opacity: 0.99;
    overflow: hidden;
    position: relative;
    border: 1px solid #ccc;
    border-radius: 3px;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.05);
}

.tiles .tile:before {
    content: "";
    background: linear-gradient(to bottom,
            rgba(0, 0, 0, 0) 0%,
            rgba(0, 0, 0, 0.7) 100%);
    /* background: #000000c4; */
    width: 100%;
    height: 50%;
    opacity: 0;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 2;
    transition-property: top, opacity;
    transition-duration: 0.3s;
}

/* .tiles .tile .thumbnail-img {
  display: block;
  min-width: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
} */
.tiles .tile .details {
    font-size: 16px;
    padding: 20px;
    color: #fff;
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
}

.tiles .tile .details span {
    display: block;
    opacity: 0;
    position: relative;
    top: 100px;
    transition-property: top, opacity;
    transition-duration: 0.3s;
    transition-delay: 0s;
}

.tiles .tile .details .title {
    line-height: 1;
    font-weight: 600;
    font-size: 18px;
}

.tiles .tile .details .info {
    line-height: 1.2;
    margin-top: 5px;
    font-size: 12px;
}

.tiles .tile:focus:before,
.tiles .tile:focus span,
.tiles .tile:hover:before,
.tiles .tile:hover span {
    opacity: 2;
}

.tiles .tile:focus:before,
.tiles .tile:hover:before {
    top: 50%;
}

.tiles .tile:focus span,
.tiles .tile:hover span {
    top: 0;
}

.tiles .tile:focus .title,
.tiles .tile:hover .title {
    transition-delay: 0.15s;
}

.tiles .tile:focus .info,
.tiles .tile:hover .info {
    transition-delay: 0.25s;
}

/* thumnails hover css ends */

body {
    font-family: Arial, sans-serif;
    margin: 0;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f4;
}

.container {
    width: 100%;
    max-width: 100%;
    background: white;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.btn {
    background-color: #007BFF;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
}

.btn:hover {
    background-color: #0888b7 !important;
}

canvas {
    width: 100%;
    border: 1px solid #ccc;
    margin-top: 20px;
}

.download-btn {
    margin-top: 33px;
    height: 36px;
    background-color: #06a6e0 !important;
}

.right {
    text-align: right;
}
</style>
